import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  ul {
    list-style: none;
  }
  figure,
  ul {
    padding: 0px;
    margin: 0px;
  }
  /**
  * 1. Correct the line height in all browsers.
  * 2. Prevent adjustments of font size after orientation changes in iOS.
  */

  html {
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /**
  * Remove the margin in all browsers.
  */

  html, body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 1.25;
    color: #333;
    -webkit-tap-highlight-color: transparent;
    @media screen and (max-width: 370px) {
      font-size: 14px;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-size: inherit;
  }

  * {
    box-sizing: border-box;
  }

  *::after,*::before{
    box-sizing:border-box;
  }

  /**
  * Remove the gray background on active links in IE 10.
  */

  a {
    background-color: transparent;
    text-decoration: none;
  }

  b,
  strong {
    font-weight: bolder;
  }

  p {
    margin: 0;
  }

  img {
    border-style: none;
  }

  img::selection {
    background: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
  * Show the overflow in IE.
  * 1. Show the overflow in Edge.
  */

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
  * Remove the inheritance of text transform in Edge, Firefox, and IE.
  * 1. Remove the inheritance of text transform in Firefox.
  */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
  * Correct the inability to style clickable types in iOS and Safari.
  */

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
  * Remove the inner border and padding in Firefox.
  */

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
  * Restore the focus styles unset by the previous rule.
  */

  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
  * Remove the default vertical scrollbar in IE 10+.
  */

  textarea {
    overflow: auto;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit; 
  }

  input {
    -webkit-appearance: none;
  }

  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  }

  a, button {
    cursor: pointer;
  }

  /* Common class names to be added below */
  .Ell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dB {
    display: block;
  }
  .dN {
    display: none;
  }
  .dIB {
    display: inline-block;
  }
  .dIh {
    display: inherit;
  }
  .dF {
    display: flex;
  }
  .dIF {
    display: inline-flex;
  }
  .dFA {
    display: flex;
    align-items: center;
  }
  .dIFA {
    display: inline-flex;
    align-items: center;
  }
  .f1 {
    flex: 1;
  }
  .fdC {
    flex-direction: column;
  }
  .fdR {
    flex-direction: row;
  }
  .fdrR {
    flex-direction: row-reverse;
  }
  .fs0 {
    flex-shrink: 0;
  }
  .jcC {
    justify-content: center;
  }
  .jcSA {
    justify-content: space-around;
  }
  .jcSB {
    justify-content: space-between;
  }
  .jcFE {
    justify-content: flex-end;
  }
  .aiFE {
    align-items: flex-end;
  }
  .aiFS {
    align-items: flex-start;
  }
  .aiB {
    align-items: baseline;
  }
  .boN {
    border: none;
  }
  .bCC {
    border-collapse: collapse;
  }
  .baW {
    background: white;
  }
  .br50 {
    border-radius: 50%;
  }
  .cD {
    cursor: default;
  }
  .cP {
    cursor: pointer;
  }
  .fwM{
    font-weight: 500;
  }
  .fwB{
    font-weight: bold;
  }
  .fwN {
    font-weight: normal;
  }
  .fwW {
    flex-wrap: wrap;
  }
  .fwNW {
    flex-wrap: nowrap;
  }
  .h0 {
    height: 0;
  }
  .h100 {
    height: 100%;
  }
  .h100VH {
    height: 100vh;
  }
  .hA {
    height: auto;
  }
  .m0 {
    margin: 0;
  }
  .mA {
    margin: auto;
  }
  .o0 {
    opacity: 0;
  }
  .o1 {
    opacity: 1;
  }
  .ofC {
    object-fit: cover;
  }
  .oH {
    overflow: hidden;
  }
  .oxA {
    overflow-x: auto;
  }
  .oxH {
    overflow-x: hidden;
  }
  .oyA {
    overflow-y: auto;
  }
  .oyH {
    overflow-y: hidden;
  }
  .outN {
    outline: none;
  }
  .peN {
    pointer-events: none;
  }
  .peA {
    pointer-events: all;
  }
  .pA {
    position: absolute;
  }
  .pF {
    position: fixed;
  }
  .pR {
    position: relative;
  }
  .pS {
    position: static;
  }
  .r0 {
    right: 0;
  }
  .t0 {
    top: 0;
  }
  .l0 {
    left: 0;
  }
  .b0 {
    bottom: 0;
  }
  .taC {
    text-align: center;
  }
  .taL {
    text-align: left;
  }
  .taR {
    text-align: right;
  }
  .tdN {
    text-decoration: none;
  }
  .ttC {
    text-transform: capitalize;
  }
  .ttU {
    text-transform: uppercase;
  }
  .vaM {
    vertical-align: middle;
  }
  .vH {
    visibility: hidden;
  }
  .w100 {
    width: 100%;
  }
  .wsN {
    white-space: nowrap;
  }
  .wosT {
    -webkit-overflow-scrolling: touch;
  }
  .wBA {
    word-break: break-all;
  }
  .wBW {
    word-break: break-word;
  }
  .zi0 {
    z-index: 0;
  }
  .zi1 {
    z-index: 1;
  }
  .link-text-hidden {
    position: fixed;
    left: -999px;
  }
  /*
    Typography classnames to be used on elements like input/button or already defined elements
    To be used only if Typography component is not usable
  */
  .h1 {
    font-size: ${({ theme }) => theme.typeScale.Mobile.header1};
    @media screen and (min-width: 768px) {
      font-size: ${({ theme }) => theme.typeScale.Desktop.header1};
    }
  }
  .h2 {
    font-size: ${({ theme }) => theme.typeScale.Mobile.header2};
    @media screen and (min-width: 768px) {
      font-size: ${({ theme }) => theme.typeScale.Desktop.header2};
    }
  }
  .h3 {
    font-size: ${({ theme }) => theme.typeScale.Mobile.header3};
    @media screen and (min-width: 768px) {
      font-size: ${({ theme }) => theme.typeScale.Desktop.header3};
    }
  }
  .bt1 {
    font-size: ${({ theme }) => theme.typeScale.Mobile.bodyText1};
    @media screen and (min-width: 768px) {
      font-size: ${({ theme }) => theme.typeScale.Desktop.bodyText1};
    }
  }
  .bt2 {
    font-size: ${({ theme }) => theme.typeScale.Mobile.bodyText2};
    @media screen and (min-width: 768px) {
      font-size: ${({ theme }) => theme.typeScale.Desktop.bodyText2};
    }
  }
  .bt3 {
    font-size: ${({ theme }) => theme.typeScale.Mobile.bodyText3};
    @media screen and (min-width: 768px) {
      font-size: ${({ theme }) => theme.typeScale.Desktop.bodyText3};
    }
  }
`;

export default GlobalStyles;
